import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import theme from 'theme/theme';
import Spinner from '../Spinner/Spinner';

const Wrapper = styled.div`
  position: absolute;
  top: 0; right: 0; bottom: 0; left: 0;
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  background: ${(props) => props.background};
`;
Wrapper.propTypes = {
  color: PropTypes.string,
  background: PropTypes.string,
};
Wrapper.defaultProps = {
  color: theme.colors.primary,
  background: theme.colors.medium,
};

const Label = styled.div`
  margin-bottom: 20px;
  color: ${(props) => props.color};
  text-align: center;
  font-size: ${theme.fontSizes.large};
`;
Label.propTypes = {
  color: PropTypes.string,
};
Label.defaultProps = {
  color: theme.colors.primary,
};

const SpinnerOverlay = ({ label, color, ...other }) => (
  <Wrapper color={color} {...other}>
    <Label color={color}>{label}</Label>
    <Spinner color={color} />
  </Wrapper>
);
SpinnerOverlay.propTypes = {
  label: PropTypes.string,
  color: PropTypes.string,
  background: PropTypes.string,
};
SpinnerOverlay.defaultProps = {
  label: 'Loading',
  color: theme.colors.primary,
  background: 'rgba(255, 255, 255, 0.97)',
};

export default SpinnerOverlay;
